module.exports = { domain:"messages",
  locale_data:{ messages:{ "":{ domain:"messages",
        plural_forms:"nplurals=1; plural=0;",
        lang:"zh_TW" },
      "Loading…":[ "載入中…" ],
      "Adding…":[ "加入中…" ],
      "Select a collection…":[ "選擇收藏集…" ],
      "Create new collection":[ "建立新收藏集" ],
      "Added to %(collectionName)s":[ "已新增到 %(collectionName)s" ],
      "Add to…":[ "新增到…" ],
      "Edit add-on":[ "編輯附加元件" ],
      "Admin add-on":[ "管理員附加元件" ],
      "Content review add-on":[ "附加元件內容審核" ],
      "Review theme":[ "審核佈景主題" ],
      "Review add-on code":[ "審核附加元件程式碼" ],
      "%(average)s (%(count)s review)":[ "%(average)s（%(count)s 筆評分）" ],
      "%(average)s (%(count)s reviews)":[ "%(average)s（%(count)s 筆評分）" ],
      "%(count)s User":[ "%(count)s 位使用者" ],
      "No Users":[ "無使用者" ],
      "Available on Firefox for Android™":[ "也可在 Firefox for Android™ 使用" ],
      Experimental:[ "實驗中" ],
      "Some features may require payment":[ "某些功能可能需要付款後才能使用" ],
      "This add-on is not compatible with your version of Firefox.":[ "這個附加元件與您所使用的 Firefox 版本不相容。" ],
      "This add-on is not available on your platform.":[ "這個附加元件與無法在您的平台使用。" ],
      "%(total)s user":[ "%(total)s 位使用者" ],
      "Report this add-on to Mozilla":[ "向 Mozilla 檢舉此附加元件" ],
      "Send some feedback about the add-on":[ "傳送有關附加元件的意見回饋" ],
      "Report the add-on because it's illegal or incompliant":[ "回報某一套附加元件不符合相關法規" ],
      "%(addonName)s – Get this Extension for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox 擴充套件（%(locale)s）" ],
      "%(addonName)s – Get this Language Pack for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox 語言套件（%(locale)s）" ],
      "%(addonName)s – Get this Theme for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox 佈景主題（%(locale)s）" ],
      "%(addonName)s – Get this Add-on for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox 附加元件（%(locale)s）" ],
      "Download %(addonName)s for Firefox. %(summary)s":[ "下載 Firefox 上的 %(addonName)s。%(summary)s" ],
      "%(addonName)s – Get this Dictionary for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox Android 字典（%(locale)s）" ],
      "%(addonName)s – Get this Extension for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox Android 擴充套件（%(locale)s）" ],
      "%(addonName)s – Get this Language Pack for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox Android 語言套件（%(locale)s）" ],
      "%(addonName)s – Get this Theme for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox Android 佈景主題（%(locale)s）" ],
      "%(addonName)s – Get this Add-on for 🦊 Firefox Android (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox Android 附加元件（%(locale)s）" ],
      "%(addonName)s – Get this Dictionary for 🦊 Firefox (%(locale)s)":[ "%(addonName)s – 下載 🦊 Firefox 字典（%(locale)s）" ],
      Homepage:[ "首頁" ],
      "Support site":[ "技術支援網站" ],
      "Support Email":[ "技術支援信箱" ],
      "Visit stats dashboard":[ "造訪統計儀錶板" ],
      "Custom License":[ "自訂授權" ],
      "%(timeFromNow)s (%(date)s)":[ "%(timeFromNow)s (%(date)s)" ],
      "Read the privacy policy for this add-on":[ "閱讀此附加元件的隱私權保護政策" ],
      "Read the license agreement for this add-on":[ "閱讀此附加元件的授權協議" ],
      "See all versions":[ "瀏覽所有版本" ],
      "Add-on Links":[ "附加元件網址" ],
      Version:[ "版本" ],
      Size:[ "大小" ],
      "Last updated":[ "最近更新" ],
      "Related Categories":[ "相關分類" ],
      License:[ "授權條款" ],
      "Privacy Policy":[ "隱私權保護政策" ],
      "End-User License Agreement":[ "終端使用者授權協議" ],
      "Version History":[ "版本紀錄" ],
      "Usage Statistics":[ "使用統計" ],
      Tags:[ "標籤" ],
      "Add to collection":[ "新增至收藏集" ],
      "Admin Links":[ "附加元件鏈結" ],
      "Author Links":[ "作者網址" ],
      "More information":[ "更多資訊" ],
      "Other users with this extension also installed":[ "其他安裝了這套擴充套件的使用者，也安裝的套件" ],
      "Other popular extensions":[ "其他知名擴充套件" ],
      "You reported this add-on":[ "您已檢舉此附加元件" ],
      "We have received your report. Thanks for letting us know about your concerns with this add-on.":[ "已收到您的回報。感謝讓我們知道這個附加元件可能有問題。" ],
      "Report this add-on":[ "檢舉此附加元件" ],
      "Edit reply":[ "編輯回覆" ],
      "Edit review":[ "編輯評論" ],
      "Delete reply":[ "刪除回覆" ],
      "Delete rating":[ "刪除評分" ],
      "Delete review":[ "刪除評論" ],
      "Do you really want to delete this reply?":[ "您真的要刪除這筆回覆嗎？" ],
      "Do you really want to delete this rating?":[ "您真的要刪除這筆評分嗎？" ],
      "Do you really want to delete this review?":[ "您真的要刪除這筆評論嗎？" ],
      Delete:[ "刪除" ],
      Cancel:[ "取消" ],
      "Keep reply":[ "保留回覆" ],
      "Keep rating":[ "保留評分" ],
      "Keep review":[ "保留評論" ],
      "Write a reply to this review.":[ "對此評論撰寫回覆。" ],
      "Update reply":[ "更新回覆" ],
      "Publish reply":[ "發布回覆" ],
      "Updating reply":[ "正在更新回覆" ],
      "Publishing reply":[ "正在發布回覆" ],
      "posted %(linkStart)s%(timestamp)s%(linkEnd)s":[ "張貼於 %(linkStart)s%(timestamp)s%(linkEnd)s" ],
      "by %(linkUserProfileStart)s%(authorName)s%(linkUserProfileEnd)s, %(linkStart)s%(timestamp)s%(linkEnd)s":[ "來自 %(linkUserProfileStart)s%(authorName)s%(linkUserProfileEnd)s，%(linkStart)s%(timestamp)s%(linkEnd)s" ],
      "Deleting…":[ "刪除中…" ],
      "Reply to this review":[ "回覆此評論" ],
      "This rating or review has been deleted. You are only seeing it because of elevated permissions.":[ "此評價或評論已經刪除，因為權限提升才會看到本項目。" ],
      "Write a review":[ "撰寫評論" ],
      "Write about your experience with this add-on.":[ "撰寫您使用此附加元件時的體驗如何。" ],
      "Submit review":[ "送出評論" ],
      "Submitting review":[ "正在送出評論" ],
      "Update review":[ "更新評論" ],
      "Updating review":[ "正在更新評論" ],
      Saving:[ "儲存中" ],
      Saved:[ "已儲存" ],
      "Please follow our %(linkStart)sreview guidelines%(linkEnd)s.":[ "請遵守我們的%(linkStart)s評論撰寫指南%(linkEnd)s。" ],
      "Your star rating:":[ "您的星等評等:" ],
      "More dictionaries by %(author)s":[ "%(author)s 製作的更多字典" ],
      "More dictionaries by these translators":[ "這些翻譯者製作的更多字典" ],
      "More extensions by %(author)s":[ "%(author)s 製作的更多擴充套件" ],
      "More extensions by these developers":[ "這些開發者製作的更多擴充套件" ],
      "Extensions by %(author)s":[ "%(author)s 製作的擴充套件" ],
      "Extensions by these developers":[ "這些開發者製作的擴充套件" ],
      "More language packs by %(author)s":[ "%(author)s 製作的更多語言套件" ],
      "More language packs by these translators":[ "這些翻譯者製作的更多語言套件" ],
      "More themes by %(author)s":[ "%(author)s 製作的更多佈景主題" ],
      "More themes by these artists":[ "這些藝術家製作的更多佈景主題" ],
      "Themes by %(author)s":[ "%(author)s 製作的佈景主題" ],
      "Themes by these artists":[ "這些藝術家製作的佈景主題" ],
      "More add-ons by %(author)s":[ "%(author)s 製作的更多附加元件" ],
      "More add-ons by these developers":[ "這些開發者製作的更多附加元件" ],
      "More powerful tools for translations, writing & grammar support":[ "更多翻譯、寫作與文法檢查的強大工具" ],
      "More amazing extensions to change the way Firefox looks":[ "更多能改變 Firefox 外觀的酷炫擴充套件" ],
      "More incredible social media extensions":[ "更多優秀的社群媒體擴充套件" ],
      "More excellent search extensions":[ "更多精湛的搜尋擴充套件" ],
      "More great extensions for feeds, news & media":[ "更多資訊來源、新聞與媒體的擴充套件" ],
      "More great notification extensions":[ "更多超棒的通知擴充套件" ],
      "More great tools for web developers":[ "更多給網頁開發者使用的超棒工具" ],
      "See Firefox Staff Picks":[ "看看 Firefox 員工精選項目" ],
      "Explore our 'Starter Pack' to get started with extensions":[ "探索我們的「入門大禮包」來開始使用擴充套件" ],
      "More powerful privacy & security extensions":[ "更多強大的隱私與安全性擴充套件" ],
      "More incredible download managers":[ "更強大的下載管理員" ],
      "More fantastic tab & bookmark extensions":[ "更棒的分頁與書籤管理擴充套件" ],
      "More great extensions for games & entertainment":[ "更棒的遊戲與娛樂擴充套件" ],
      "More amazing image, photo & media extensions":[ "更棒的圖片、拍照與媒體內容擴充套件" ],
      "Add-on icon":[ "附加元件圖示" ],
      "%(rating)s Star out of 5":[ "%(rating)s 顆星，滿分 5 顆星" ],
      ",":[ "、" ],
      by:[ "作者:" ],
      "Source code released under %(linkStart)s%(licenseName)s%(linkEnd)s":[ "原始碼依照 %(linkStart)s%(licenseName)s%(linkEnd)s 條款釋出" ],
      "Source code released under %(linkStart)sCustom License%(linkEnd)s":[ "原始碼依照%(linkStart)s自訂授權%(linkEnd)s條款釋出" ],
      "Source code released under %(licenseName)s":[ "原始碼依照 %(licenseName)s 條款釋出" ],
      "No version found":[ "沒有找到版本" ],
      "Version %(versionNumber)s":[ "版本 %(versionNumber)s" ],
      "Released %(dateReleased)s - %(fileSize)s":[ "發行於 %(dateReleased)s - %(fileSize)s" ],
      Enable:[ "啟用" ],
      Remove:[ "移除" ],
      Enabling:[ "已啟用" ],
      Disabling:[ "停用中" ],
      Downloading:[ "下載中" ],
      Installing:[ "安裝中" ],
      Uninstalling:[ "移除中" ],
      "Install Theme":[ "安裝佈景主題" ],
      "Add to Firefox":[ "新增至 Firefox" ],
      "Add-ons for Firefox (%(locale)s)":[ "Firefox 附加元件站（%(locale)s）" ],
      "%(title)s – Add-ons for Firefox (%(locale)s)":[ "%(title)s – Firefox 附加元件站（%(locale)s）" ],
      "Add-ons for Firefox Android (%(locale)s)":[ "Firefox Android 附加元件站（%(locale)s）" ],
      "%(title)s – Add-ons for Firefox Android (%(locale)s)":[ "%(title)s – Firefox Android 附加元件站（%(locale)s）" ],
      "Log out":[ "登出" ],
      "Log in":[ "登入" ],
      "This action is currently unavailable. Please reload the page in a moment.":[ "目前暫時無法進行此操作，請稍後重新載入頁面。" ],
      Loading:[ "載入中" ],
      "Find add-ons":[ "尋找附加元件" ],
      Search:[ "搜尋" ],
      Categories:[ "分類" ],
      "Loading categories.":[ "正在載入分類。" ],
      "No categories found.":[ "找不到分類。" ],
      "Added to collection":[ "已新增至收藏集" ],
      "Removed from collection":[ "已自收藏集移除" ],
      "Find an add-on to include in this collection":[ "將附加元件放進這套收藏集中" ],
      "Edit this collection":[ "編輯這個收藏集" ],
      "Edit collection details":[ "編輯收藏集資訊" ],
      "Back to collection":[ "回到收藏集" ],
      "Add-ons":[ "附加元件" ],
      Creator:[ "建立者" ],
      "Create collection":[ "建立收藏集" ],
      "Save changes":[ "儲存變更" ],
      "Collection name":[ "收藏集名稱" ],
      Description:[ "描述" ],
      "Custom URL":[ "自訂 URL" ],
      "Sort add-ons by":[ "附加元件排序方式" ],
      "Newest first":[ "最新的優先" ],
      "Oldest first":[ "最舊的優先" ],
      Name:[ "名稱" ],
      Popularity:[ "熱門度" ],
      Confirm:[ "確認" ],
      "Contribute now":[ "立刻捐款" ],
      "Support this developer":[ "支援這位開發者" ],
      "Support these developers":[ "支援這些開發者" ],
      "The developer of this extension asks that you help support its continued development by making a small contribution.":[ "這套擴充套件的開發者希望您透過小小的捐獻協助其後續開發。" ],
      "The developers of this extension ask that you help support its continued development by making a small contribution.":[ "這套擴充套件的開發者希望您透過小小的捐獻協助其後續開發。" ],
      "Support this artist":[ "支援這位藝術家" ],
      "Support these artists":[ "支援這些藝術家" ],
      "The artist of this theme asks that you help support its continued creation by making a small contribution.":[ "這套佈景主題的開發者希望您透過小小的捐獻協助其後續開發。" ],
      "The artists of this theme ask that you help support its continued creation by making a small contribution.":[ "這套佈景主題的開發者希望您透過小小的捐獻協助其後續開發。" ],
      "Support this author":[ "支援這位作者" ],
      "Support these authors":[ "支援這些作者" ],
      "The author of this add-on asks that you help support its continued work by making a small contribution.":[ "這套附加元件的開發者希望您透過小小的捐獻協助其後續開發。" ],
      "The authors of this add-on ask that you help support its continued work by making a small contribution.":[ "這套附加元件的開發者希望您透過小小的捐獻協助其後續開發。" ],
      "Enter text.":[ "輸入文字。" ],
      Submit:[ "送出" ],
      Submitting:[ "送出中" ],
      "Leave a note":[ "留下註解" ],
      "Collector's note":[ "收藏集說明" ],
      "Add a comment about this add-on.":[ "新增此附加元件的評論。" ],
      Save:[ "儲存" ],
      Edit:[ "編輯" ],
      "Your session has expired":[ "您的登入階段已逾期" ],
      "An unexpected error occurred":[ "發生未預期的錯誤" ],
      "Reload To Continue":[ "重新載入以繼續" ],
      "Page not found":[ "找不到頁面" ],
      "Sorry, but we can't find anything at the URL you entered.":[ "很抱歉，我們找不到您輸入的網址的資料內容。" ],
      "Error code: %(status)s.":[ "錯誤代碼: %(status)s。" ],
      "Login authentication has expired. %(startLink)sReload the page%(endLink)s to continue without authentication, or login again using the Log In link at the top of the page.":[ "登入狀態已過期。%(startLink)s請重新載入頁面%(endLink)s即可以登出狀態紀錄瀏覽，或請點擊頁面頂部的「登入」鏈結重新登入。" ],
      "Login Expired":[ "登入狀態已失效" ],
      "If you are signed in and think this message is an error, please <a href=\"%(url)s\">file an issue</a>. Tell us where you came from and what you were trying to access, and we'll fix the issue.":[ "若您已登入，認為訊息有誤，請<a href=\"%(url)s\">回報問題</a>。請在回報的資料當中包含您是從哪個網址過來、想要存取什麼知道，我們將修正此問題。" ],
      "Not Authorized":[ "未授權" ],
      "Sorry, but you aren't authorized to access this page. If you aren't signed in, try signing in using the link at the top of the page.":[ "抱歉，您無權存取此頁面。若您並未登入，請先使用頁面頂端的鏈結登入。" ],
      "Try visiting the page later, as the theme or extension may become available again. Alternatively, you may be able to find what you’re looking for in one of the available %(extensionStart)sextensions%(extensionEnd)s or %(themeStart)sthemes%(themeEnd)s, or by asking for help on our %(communityStart)scommunity forums%(communityEnd)s.":[ "請稍後再開啟這個頁面，佈景主題或擴充套件可能會再次上架。另外您可以在下列%(extensionStart)s擴充套件%(extensionEnd)s或%(themeStart)s佈景主題%(themeEnd)s頁面中，尋找是否有您要的內容。也可以到我們的%(communityStart)s社群討論區%(communityEnd)s發問。" ],
      "Oops! We can’t find that page":[ "哎呀！找不到這一頁" ],
      "If you’ve followed a link from another site for an extension or theme, that item is no longer available. This could be because:":[ "若您從其他網站上過來，想尋找某套擴充套件或佈景主題，該項目已經無法使用。這可能是因為:" ],
      "The developer removed it. Developers commonly do this because they no longer support the extension or theme, or have replaced it.":[ "開發者主動下架。他們通常會因為不再支援該套件或佈景主題，或推出取代的版本而這麼做。" ],
      "Mozilla removed it. This can happen when issues are found during the review of the extension or theme, or the extension or theme has been abusing the terms and conditions for addons.mozilla.org. The developer has the opportunity to resolve the issues and make the add-on available again.":[ "Mozilla 已將其下架。這可能是因為在審核擴充套件或佈景主題的過程中發現問題，或是該套件或主題違反了 addons.mozilla.org 的使用條款。開發者會有機會解決問題，並重新上架。" ],
      "If you have additional information that would help us you can <a href=\"https://github.com/mozilla/addons-frontend/issues/new/\">file an issue</a>. Tell us what steps you took that lead to the error and we'll do our best to fix it.":[ "若您有其他能夠幫助我們修正的資訊，您可以<a href=\"https://github.com/mozilla/addons-frontend/issues/new/\">回報問題</a>。請告訴我們您做了哪些事情後錯誤發生，我們會盡力修正。" ],
      "Server Error":[ "伺服器錯誤" ],
      "Sorry, but there was an error with our server and we couldn't complete your request. We have logged this error and will investigate it.":[ "抱歉，我們的伺服器上有錯誤發生，無法完成請求。我們已經記錄下此錯誤，將再行修復。" ],
      "You may be able to find what you’re looking for in one of the available %(extensionStart)sextensions%(extensionEnd)s or %(themeStart)sthemes%(themeEnd)s, or by asking for help on our %(communityStart)scommunity forums%(communityEnd)s.":[ "您可以在下列%(extensionStart)s擴充套件%(extensionEnd)s或%(themeStart)s佈景主題%(themeEnd)s頁面中，尋找是否有您要的內容。也可以到我們的%(communityStart)s社群討論區%(communityEnd)s發問。" ],
      "That page is not available in your region":[ "這個頁面並未向您所在的地區提供。" ],
      "The page you tried to access is not available in your region.":[ "您嘗試開啟的內容並未向您所在的地區提供。" ],
      "Toggle contents":[ "切換內容" ],
      "Response by %(userName)s":[ "%(userName)s 的回應" ],
      "Review by %(userName)s":[ "%(userName)s 所留下的評論" ],
      "The review was not found.":[ "找不到此評論。" ],
      "By submitting this report I certify, under penalty of perjury, that the allegations it contains are complete and accurate, to the best of my knowledge.":[ "我保證送出的檢舉內容完整且準確，否則願負相關法律責任。" ],
      "It doesn’t work, breaks websites, or slows down Firefox":[ "無法正常運作、造成網站故障，或拖慢 Firefox" ],
      "Example: Features are slow, hard to use, or don’t work; parts of websites won't load or look unusual.":[ "例如：某些功能運作很慢、很難或無法使用，或是造成某些網站中的一部分無法載入，或看起來不正常。" ],
      "It’s spam":[ "是垃圾套件" ],
      "Example: The listing advertises unrelated products or services.":[ "例如：此附加元件會投放無關的產品或廣告。" ],
      "It violates Add-on Policies":[ "違反附加元件政策" ],
      "Example: It compromised my data without informing or asking me, or it changed my search engine or home page without informing or asking me.":[ "例如：這套元件沒有先通知或詢問過我就外流我的資料，或是沒有先通知或詢問過我就更改了我的瀏覽器首頁或搜尋引擎。" ],
      "It contains hateful, violent, deceptive, or other inappropriate content":[ "包含仇恨、暴力、欺詐或其他不適當的內容" ],
      "Example: It contains racist imagery.":[ "例如：包含種族主義圖片。" ],
      "It violates the law or contains content that violates the law":[ "本身違反法規，或包含違反法規的內容" ],
      "Example: Fraud. (If you wish to report a copyright or trademark infringement, you can learn more about how to do so in our %(startLink)sCopyright or Trademark Infringement Reporting article%(endLink)s).":[ "例如：偽冒。（若您˙想檢舉違反著作權或商標權的情況，請參考%(startLink)s檢舉著作權或商標權侵害%(endLink)s這篇文章）" ],
      "Something else":[ "其他原因" ],
      "Anything that doesn’t fit into the other categories.":[ "任何不屬於其他分類的內容。" ],
      "Select place":[ "選擇位置" ],
      "On the add-on's page on this website":[ "此網站上的附加元件頁面" ],
      "Inside the add-on":[ "附加元件內" ],
      "Both locations":[ "兩個位置都有" ],
      "Select type":[ "選擇類型" ],
      "Animal welfare":[ "動物福利" ],
      "Consumer information infringements":[ "侵犯消費者資訊" ],
      "Data protection and privacy violations":[ "資料保護與隱私權侵犯" ],
      "Illegal or harmful speech":[ "非法或有害的言論" ],
      "Intellectual property infringements":[ "侵犯智慧財產權" ],
      "Negative effects on civic discourse or elections":[ "對公民論述或選舉有負面影響" ],
      "Non-consensual behavior":[ "未經同意的行為" ],
      "Pornography or sexualized content":[ "色情內容" ],
      "Protection of minors":[ "未成年人保護" ],
      "Risk for public security":[ "公共安全風險" ],
      "Scams or fraud":[ "詐騙、偽冒內容" ],
      "Self-harm":[ "自我傷害" ],
      "Unsafe, non-compliant, or prohibited products":[ "不安全、不合規，或被禁止的產品" ],
      Violence:[ "暴力內容" ],
      Other:[ "其他" ],
      "Select violation":[ "選擇違反情況" ],
      "Insufficient information on traders":[ "業者資訊不足" ],
      "Non-compliance with pricing regulations":[ "違反價格法規" ],
      "Hidden advertisement or commercial communication, including by influencers":[ "隱藏廣告，或商業傳播內容（包含置入於網紅內容）" ],
      "Misleading information about the characteristics of the goods and services":[ "誤導商品或服務特徵的資訊" ],
      "Misleading information about the consumer’s rights":[ "誤導消費者權利的資訊" ],
      "Biometric data breach":[ "發生生物識別資料外洩事件" ],
      "Missing processing ground for data":[ "缺少資料處理的背景" ],
      "Right to be forgotten":[ "被遺忘權" ],
      "Data falsification":[ "偽造資料" ],
      Defamation:[ "誹謗" ],
      Discrimination:[ "歧視" ],
      "Illegal incitement to violence and hatred based on protected characteristics (hate speech)":[ "非法煽動暴力行為，以及對於應保護族群的仇恨言論" ],
      "Design infringements":[ "侵犯設計內容" ],
      "Geographical indications infringements":[ "侵犯產品地理標誌" ],
      "Patent infringements":[ "侵犯專利" ],
      "Trade secret infringements":[ "侵犯商業秘密" ],
      "Violation of EU law relevant to civic discourse or elections":[ "違反與公民論述或選舉相關的歐盟法律" ],
      "Violation of national law relevant to civic discourse or elections":[ "違反與公民論述或選舉相關的國家法律" ],
      "Misinformation, disinformation, foreign information manipulation and interference":[ "錯誤資訊、造謠、外國介入的資訊操弄與干擾" ],
      "Non-consensual image sharing":[ "未經同意分享圖片" ],
      "Non-consensual items containing deepfake or similar technology using a third party's features":[ "未經同意，使用第三方軟體產製包含 Deepfake 或類似技術的內容" ],
      "Online bullying/intimidation":[ "網路霸凌、恐嚇" ],
      Stalking:[ "跟蹤騷擾" ],
      "Adult sexual material":[ "成人色情內容" ],
      "Image-based sexual abuse (excluding content depicting minors)":[ "以圖片進行性虐待（不含描繪兒童的內容）" ],
      "age-specific restrictions concerning minors":[ "與兒童有關的特定年齡限制" ],
      "Child sexual abuse material":[ "兒童性虐待內容" ],
      "Grooming/sexual enticement of minors":[ "誘拐兒童、對兒童進行性引誘" ],
      "Illegal organizations":[ "違法組織" ],
      "Risk for environmental damage":[ "對環境破壞造成風險" ],
      "Risk for public health":[ "對公共健康造成風險" ],
      "Terrorist content":[ "恐怖主義內容" ],
      "Inauthentic accounts":[ "虛假帳號" ],
      "Inauthentic listings":[ "虛假商品資訊" ],
      "Inauthentic user reviews":[ "虛假評價" ],
      "Impersonation or account hijacking":[ "假冒或綁架帳號" ],
      Phishing:[ "釣魚內容" ],
      "Pyramid schemes":[ "多層次傳銷" ],
      "Content promoting eating disorders":[ "宣傳飲食障礙的內容" ],
      "Self-mutilation":[ "自殘" ],
      Suicide:[ "自殺" ],
      "Prohibited or restricted products":[ "被禁止或限制使用的產品" ],
      "Unsafe or non-compliant products":[ "不安全或不符合相關規定的產品" ],
      "Coordinated harm":[ "協同傷害" ],
      "Gender-based violence":[ "性別暴力" ],
      "Human exploitation":[ "人力剝削" ],
      "Human trafficking":[ "人口販運" ],
      "General calls or incitement to violence and/or hatred":[ "一般性煽動暴力和/或仇恨內容" ],
      "Report submitted":[ "已送出回報內容" ],
      "We have received your report. Thanks for letting us know.":[ "我們已收到您回報的內容，感謝您通知我們。" ],
      "Submitting your report…":[ "正在送出您的回報內容…" ],
      "Submit report":[ "送出報告" ],
      "Provide more information":[ "提供更多資訊" ],
      "Place of the violation":[ "違反行為發生位置" ],
      "Type of illegal content":[ "違法內容的類型" ],
      "Specific violation":[ "請選擇違規情況" ],
      "Provide more details":[ "提供更多詳情" ],
      "Please provide any additional information that may help us to understand your report (including which policy you believe has been violated).":[ "請提供任何能夠幫助我們了解您檢舉內容的相關資訊（包含您認為該內容違反的政策項目）。" ],
      "Contact information":[ "聯絡資訊" ],
      "File report anonymously":[ "匿名回報" ],
      "Filing an anonymous report will prevent us from communicating with you about the report’s status, or about any options for appeal.":[ "若匿名提出檢舉，我們將無法提供有關檢舉內容的處理情況，或是針對處理結果再提出申訴。" ],
      "Your name %(spanStart)s(optional)%(spanEnd)s":[ "您的姓名%(spanStart)s（選填）%(spanEnd)s" ],
      "Your name %(spanStart)s(required)%(spanEnd)s":[ "您的姓名%(spanStart)s（必填）%(spanEnd)s" ],
      "Your email address %(spanStart)s(optional)%(spanEnd)s":[ "您的電子郵件地址%(spanStart)s（選填）%(spanEnd)s" ],
      "Your email address %(spanStart)s(required)%(spanEnd)s":[ "您的電子郵件地址%(spanStart)s（必填）%(spanEnd)s" ],
      "Content that is illegal or that violates AMO's content policies":[ "內容違法，或違反 AMO 的內容政策" ],
      Flagged:[ "已標示" ],
      Flag:[ "標示" ],
      "Flag this developer response":[ "標示這則開發者回應" ],
      "Flag this review":[ "標示此評論" ],
      Spam:[ "垃圾評論" ],
      "Flagged as spam":[ "已標示為垃圾留言" ],
      "Login required":[ "需要登入" ],
      "Misplaced bug report or support request":[ "誤置的臭蟲回報或是技術支援要求" ],
      "Flagged as misplaced bug report or support request":[ "已標示為「誤置的臭蟲回報或是技術支援要求」" ],
      "Developer Policies":[ "開發者政策" ],
      "Community Blog":[ "社群部落格" ],
      Forum:[ "討論區" ],
      "Report a bug":[ "回報 Bug" ],
      "Review Guide":[ "評論撰寫指南" ],
      Browsers:[ "瀏覽器" ],
      Products:[ "產品" ],
      Privacy:[ "隱私權" ],
      Cookies:[ "Cookie" ],
      Legal:[ "法律資訊" ],
      "Except where otherwise %(startNotedLink)snoted%(endNotedLink)s, content on this site is licensed under the %(startLicenseLink)sCreative Commons Attribution Share-Alike License v3.0%(endLicenseLink)s or any later version. Android is a trademark of Google LLC.":[ "除另有%(startNotedLink)s註明%(endNotedLink)s外，本站內容皆採用%(startLicenseLink)s創用 CC 姓名標示—相同方式分享條款 3.0%(endLicenseLink)s 或更新版本授權大眾使用。Android 是 Google LLC 的註冊商標。" ],
      "Except where otherwise %(startNotedLink)snoted%(endNotedLink)s, content on this site is licensed under the %(startLicenseLink)sCreative Commons Attribution Share-Alike License v3.0%(endLicenseLink)s or any later version.":[ "除另有%(startNotedLink)s註明%(endNotedLink)s外，本站內容皆採用%(startLicenseLink)s創用 CC 姓名標示—相同方式分享條款 3.0%(endLicenseLink)s 或更新版本授權大眾使用。" ],
      "Go to Mozilla's homepage":[ "前往 Mozilla 官網" ],
      About:[ "關於" ],
      "Firefox Add-ons Blog":[ "Firefox 附加元件部落格" ],
      "Extension Workshop":[ "擴充套件工作坊" ],
      "Developer Hub":[ "開發者交流中心" ],
      "To use these add-ons, you'll need to %(downloadLinkStart)sdownload Firefox%(downloadLinkEnd)s.":[ "必須%(downloadLinkStart)s下載 Firefox%(downloadLinkEnd)s 才能使用這些附加元件。" ],
      "To use Android extensions, you'll need %(downloadLinkStart)sFirefox for Android%(downloadLinkEnd)s. To explore Firefox for desktop add-ons, please %(linkStart)svisit our desktop site%(linkEnd)s.":[ "必須安裝 %(downloadLinkStart)sFirefox for Android%(downloadLinkEnd)s 才可以使用 Android 擴充套件。若要尋找 Firefox 桌面版的附加元件，請到我們的 %(linkStart)s桌面版網站%(linkEnd)s。" ],
      "Download Firefox and get the theme":[ "下載 Firefox 並安裝佈景主題" ],
      "Download Firefox and get the extension":[ "下載 Firefox 並安裝擴充套件" ],
      "Download the new Firefox and get the theme":[ "下載新版 Firefox 並安裝佈景主題" ],
      "Download the new Firefox and get the extension":[ "下載新版 Firefox 並安裝擴充套件" ],
      "Download Firefox":[ "下載 Firefox" ],
      Tools:[ "工具" ],
      "Submit a New Add-on":[ "上架新附加元件" ],
      "Submit a New Theme":[ "上架新佈景主題" ],
      "Manage My Submissions":[ "管理我上架的項目" ],
      "Reviewer Tools":[ "審核者工具" ],
      "Firefox Browser Add-ons":[ "Firefox 瀏覽器附加元件" ],
      "Learn how to create extensions and themes":[ "了解如何建立擴充套件與佈景主題" ],
      "Submit and manage extensions and themes":[ "送出並管理擴充套件與佈景主題" ],
      "My Account":[ "我的帳號" ],
      "View My Collections":[ "檢視我的收藏集" ],
      "View My Profile":[ "檢視我的個人資料" ],
      "Edit My Profile":[ "編輯我的個人資料" ],
      "Get the extension":[ "安裝擴充套件" ],
      RECOMMENDED:[ "推薦" ],
      "BY FIREFOX":[ "由 FIREFOX 打造" ],
      PROMOTED:[ "推廣" ],
      "Firefox only recommends extensions that meet our standards for security and performance.":[ "Firefox 僅推薦符合我們的安全性與運作效能標準的擴充套件。" ],
      "See more %(categoryName)s":[ "看更多%(categoryName)s" ],
      "Access your data for all websites":[ "存取您所有網站中的資料" ],
      "Access your data for sites in the %(param)s domain":[ "存取您在 %(param)s 網域中的資料" ],
      "Access your data for %(param)s":[ "存取您在 %(param)s 的資料" ],
      "Download file":[ "下載檔案" ],
      "Learn more":[ "了解更多" ],
      "This add-on is not actively monitored for security by Mozilla. Make sure you trust it before installing.":[ "此附加元件未經 Mozilla 主動檢查安全性，請確定您信任此元件再安裝。" ],
      "Change language":[ "變更語言" ],
      "Dismiss this notice":[ "忽略此通知" ],
      Previous:[ "上一個" ],
      Next:[ "下一個" ],
      "Page %(thisPage)s of %(totalPages)s":[ "第 %(thisPage)s 頁，共 %(totalPages)s 頁" ],
      "Optional permissions:":[ "選用的權限：" ],
      "Optional data collection, according to the developer:":[ "開發者聲稱選擇性收集下列資料：" ],
      "Data collection:":[ "收集下列資料：" ],
      "Required data collection, according to the developer:":[ "開發者聲稱必須收集下列資料：" ],
      "Permissions and data":[ "權限與資料" ],
      "Required permissions:":[ "必要權限：" ],
      "Read and modify bookmarks":[ "讀取或修改書籤" ],
      "Read and modify browser settings":[ "讀取或修改瀏覽器設定" ],
      "Clear recent browsing history, cookies, and related data":[ "清除最近的瀏覽紀錄、Cookie 等相關資料" ],
      "Get data from the clipboard":[ "取得剪貼簿中的資料" ],
      "Input data to the clipboard":[ "輸入資料到剪貼簿" ],
      "Block content on any page":[ "封鎖任何頁面上的內容" ],
      "Read your browsing history":[ "讀取您的上網紀錄" ],
      "Extend developer tools to access your data in open tabs":[ "讓開發者工具可存取您在開啟分頁中的資料" ],
      "Download files and read and modify the browser’s download history":[ "下載檔案、讀取或修改瀏覽器的下載紀錄" ],
      "Open files downloaded to your computer":[ "開啟下載到您電腦上的檔案" ],
      "Read the text of all open tabs":[ "讀取所有開啟分頁當中的文字內容" ],
      "Access your location":[ "取得您的所在位置" ],
      "Access browsing history":[ "取得瀏覽紀錄" ],
      "Monitor extension usage and manage themes":[ "監控擴充套件使用情況並管理佈景主題" ],
      "Exchange messages with programs other than Firefox":[ "與 Firefox 以外的程式交換訊息" ],
      "Display notifications to you":[ "向您顯示通知" ],
      "Provide cryptographic authentication services":[ "提供加密驗證服務" ],
      "Control browser proxy settings":[ "控制瀏覽器代理伺服器設定" ],
      "Read and modify privacy settings":[ "讀取或修改隱私設定" ],
      "Access recently closed tabs":[ "取得最近關閉的分頁" ],
      "Access browser tabs":[ "存取瀏覽器分頁" ],
      "Hide and show browser tabs":[ "隱藏或顯示瀏覽器分頁" ],
      "Access browser activity during navigation":[ "在上網時了解瀏覽器行為狀態" ],
      "Authentication information":[ "驗證資訊" ],
      Bookmarks:[ "書籤" ],
      "Browsing activity":[ "上網行為" ],
      "Financial and payment information":[ "財務與付款資訊" ],
      "Health information":[ "健康資訊" ],
      Location:[ "地點" ],
      "Personal communications":[ "私人通訊內容" ],
      "Personally identifying information":[ "可識別個人資訊" ],
      "Search terms":[ "搜尋關鍵字" ],
      "Technical and interaction data":[ "技術與互動資料" ],
      "Website activity":[ "網站使用紀錄" ],
      "Website content":[ "網站內容" ],
      "The developer says this extension doesn't require data collection.":[ "開發者聲稱此擴充套件不要求收集任何資料。" ],
      "Rated %(rating)s out of 5":[ "評價 %(rating)s 分，滿分 5 分" ],
      "Update your rating to %(starRating)s out of 5":[ "更新您的評分為 %(starRating)s 分，滿分 5 分" ],
      "Rate this add-on %(starRating)s out of 5":[ "為這套附加元件評價 %(starRating)s 分，滿分 5 分" ],
      "There are no ratings yet":[ "目前沒有評分" ],
      "Log in to rate this dictionary":[ "登入後即可為此字典評分" ],
      "Log in to rate this language pack":[ "登入後即可為此語言套件評分" ],
      "Log in to rate this theme":[ "登入後即可為此佈景主題評分" ],
      "Log in to rate this extension":[ "登入後即可幫此擴充套件評分" ],
      "Log in to rate this add-on":[ "登入後即可為此附加元件評分" ],
      "Are you sure you want to delete your review of %(addonName)s?":[ "您真的要刪除對 %(addonName)s 的評論嗎？" ],
      "Are you sure you want to delete your rating of %(addonName)s?":[ "您真的要刪除對 %(addonName)s 的評分嗎？" ],
      "Click to rate:":[ "點擊評分：" ],
      "Saving star rating":[ "正在儲存星等" ],
      "Star rating saved":[ "已儲存星等" ],
      "There are no three-star reviews":[ "目前沒有三星評論" ],
      "Read the 1 two-star review":[ "閱讀全部 %(total)s 則二星評論" ],
      "There are no two-star reviews":[ "目前沒有二星評論" ],
      "Read the 1 one-star review":[ "閱讀全部 %(total)s 則一星評論" ],
      "There are no one-star reviews":[ "目前沒有一星評論" ],
      "There are no reviews":[ "目前沒有評論" ],
      "Read the 1 five-star review":[ "閱讀全部 %(total)s 則五星評論" ],
      "There are no five-star reviews":[ "目前沒有五星評論" ],
      "Read the 1 four-star review":[ "閱讀全部 %(total)s 則四星評論" ],
      "There are no four-star reviews":[ "目前沒有四星評論" ],
      "Read the 1 three-star review":[ "閱讀全部 %(total)s 則三星評論" ],
      "You reported this user":[ "您已檢舉此使用者" ],
      "We have received your report. Thanks for letting us know about your concerns with this user.":[ "已收到您的回報。感謝讓我們知道這位使用者可能有問題。" ],
      "Report this user":[ "檢舉此使用者" ],
      "Search results":[ "搜尋結果" ],
      "Recommended extensions":[ "推薦的擴充套件" ],
      "Recommended themes":[ "推薦的佈景主題" ],
      "Recommended add-ons":[ "推薦的附加元件" ],
      "Extensions by Firefox":[ "Firefox 原廠製作的擴充套件" ],
      "Themes by Firefox":[ "Firefox 原廠製作的佈景主題" ],
      "Add-ons by Firefox":[ "Firefox 原廠製作的附加元件" ],
      "Reviewed extensions":[ "審核過的擴充套件" ],
      "Reviewed themes":[ "審核過的佈景主題" ],
      "Reviewed add-ons":[ "審核過的附加元件" ],
      "Trending extensions":[ "熱門擴充套件" ],
      "Trending themes":[ "熱門佈景主題" ],
      "Trending add-ons":[ "嶄露頭角的附加元件" ],
      "Top rated extensions":[ "分數最高的擴充套件" ],
      "Top rated themes":[ "分數最高的佈景主題" ],
      "Top rated add-ons":[ "分數最高的附加元件" ],
      "Popular extensions":[ "熱門擴充套件" ],
      "Popular themes":[ "熱門佈景主題" ],
      "Popular add-ons":[ "熱門附加元件" ],
      "Search results for \"%(query)s\"":[ "「%(query)s」的搜尋結果" ],
      "%(count)s extension found for \"%(query)s\"":[ "找到「%(query)s」的 %(count)s 套擴充套件" ],
      "%(count)s extension found with tag %(tag)s":[ "找到標籤為 %(tag)s 的 %(count)s 套擴充套件" ],
      "%(count)s extension found":[ "找到 %(count)s 套擴充套件" ],
      "%(count)s theme found for \"%(query)s\" with tag %(tag)s in %(categoryName)s":[ "找到「%(query)s」於 %(categoryName)s 分類含有 %(tag)s 標籤的 %(count)s 套佈景主題" ],
      "%(count)s theme found for \"%(query)s\" in %(categoryName)s":[ "找到「%(query)s」於 %(categoryName)s 分類的 %(count)s 套佈景主題" ],
      "%(count)s theme found with tag %(tag)s in %(categoryName)s":[ "找到於 %(categoryName)s 分類含有 %(tag)s 標籤的 %(count)s 套佈景主題" ],
      "%(count)s theme found in %(categoryName)s":[ "找到於 %(categoryName)s 分類的 %(count)s 套佈景主題" ],
      "%(count)s theme found for \"%(query)s\" with tag %(tag)s":[ "找到「%(query)s」含有 %(tag)s 標籤的 %(count)s 套佈景主題" ],
      "%(count)s theme found for \"%(query)s\"":[ "找到「%(query)s」的 %(count)s 套佈景主題" ],
      "%(count)s theme found with tag %(tag)s":[ "找到標籤為 %(tag)s 的 %(count)s 套佈景主題" ],
      "%(count)s theme found":[ "找到 %(count)s 套佈景主題" ],
      "%(count)s result found for \"%(query)s\" with tag %(tag)s":[ "找到「%(query)s」含有 %(tag)s 標籤的 %(count)s 筆結果" ],
      "%(count)s result found for \"%(query)s\"":[ "找到「%(query)s」的 %(count)s 筆結果" ],
      "%(count)s result found with tag %(tag)s":[ "找到標籤「%(tag)s」的 %(count)s 筆結果" ],
      "%(count)s result found":[ "找到 %(count)s 筆結果" ],
      "Searching for \"%(query)s\"":[ "正在搜尋「%(query)s」" ],
      "Searching for add-ons":[ "正在搜尋附加元件" ],
      "%(count)s extension found for \"%(query)s\" with tag %(tag)s in %(categoryName)s":[ "找到「%(query)s」於 %(categoryName)s 分類含有 %(tag)s 標籤的 %(count)s 套擴充套件" ],
      "%(count)s extension found for \"%(query)s\" in %(categoryName)s":[ "找到「%(query)s」於 %(categoryName)s 分類的 %(count)s 套擴充套件" ],
      "%(count)s extension found with tag %(tag)s in %(categoryName)s":[ "找到於 %(categoryName)s 分類含有 %(tag)s 標籤的 %(count)s 套擴充套件" ],
      "%(count)s extension found in %(categoryName)s":[ "找到於 %(categoryName)s 分類的 %(count)s 套擴充套件" ],
      "%(count)s extension found for \"%(query)s\" with tag %(tag)s":[ "找到「%(query)s」含有 %(tag)s 標籤的 %(count)s 套擴充套件" ],
      All:[ "所有" ],
      Extension:[ "擴充套件" ],
      Theme:[ "佈景主題" ],
      Relevance:[ "相關性" ],
      "Recently Updated":[ "最近更新" ],
      "Most Users":[ "最多使用者" ],
      "Top Rated":[ "評分最高" ],
      Trending:[ "熱門趨勢" ],
      Any:[ "任何" ],
      Recommended:[ "推薦項目" ],
      "By Firefox":[ "由 Firefox 推出" ],
      "All Reviewed":[ "全部已審核項目" ],
      Black:[ "黑色" ],
      Gray:[ "灰色" ],
      White:[ "白色" ],
      Red:[ "紅色" ],
      Yellow:[ "黃色" ],
      Green:[ "綠色" ],
      Cyan:[ "青色" ],
      Blue:[ "藍色" ],
      Magenta:[ "洋紅色" ],
      "Filter results":[ "過濾結果" ],
      "Sort by":[ "排序依照" ],
      "Add-on Type":[ "附加元件類型" ],
      "Theme Color":[ "佈景主題色彩" ],
      Clear:[ "清除" ],
      Badging:[ "徽章" ],
      "Firefox Add-ons for Android":[ "Android 版 Firefox 的附加元件" ],
      "Firefox Add-ons":[ "Firefox 附加元件" ],
      "Go to the add-on page":[ "前往附加元件頁面" ],
      "No theme preview available":[ "沒有佈景主題預覽可以使用" ],
      "Add-on note":[ "附加元件註記" ],
      "Searching…":[ "搜尋中…" ],
      "No results were found for \"%(query)s\".":[ "沒有找到「%(query)s」的相關結果。" ],
      "No results were found.":[ "沒有找到結果。" ],
      Themes:[ "佈景主題" ],
      "More…":[ "更多…" ],
      "for Firefox":[ "用於 Firefox" ],
      "Dictionaries & Language Packs":[ "字典與語言套件" ],
      "Other Browser Sites":[ "其他瀏覽器網站" ],
      "Add-ons for Android":[ "Android 版的附加元件" ],
      Extensions:[ "擴充套件" ],
      "Expand to read more":[ "展開閱讀更多內容" ],
      "<span class=\"visually-hidden\">Expand to</span> Read more":[ "<span class=\"visually-hidden\">展開後</span> 閱讀更多" ],
      "Signed in as %(username)s":[ "已登入為 %(username)s" ],
      "Some features are temporarily disabled while we perform website maintenance. We'll be back to full capacity shortly.":[ "我們正在進行網站維護，部分功能暫時無法使用。我們將盡快完全復原。" ],
      "You have been logged out.":[ "您已登出。" ],
      "Suggested Pages":[ "推薦頁面" ],
      "Browse all extensions":[ "瀏覽所有擴充套件" ],
      "Browse all themes":[ "瀏覽所有佈景主題" ],
      "Add-ons Home Page":[ "附加元件站首頁" ],
      "Preview of %(title)s":[ "%(title)s 預覽" ],
      "%(total)s add-on":[ "%(total)s 套附加元件" ],
      "Do you really want to delete this picture?":[ "您真的要刪除這張照片嗎？" ],
      "Delete This Picture":[ "刪除此照片" ],
      "Profile picture for %(name)s":[ "%(name)s 的使用者照片" ],
      "Profile photo":[ "個人資料照片" ],
      "Choose Photo…":[ "選擇照片" ],
      "Developer response":[ "開發者回應" ],
      "Save 50% with a full year subscription":[ "一次訂閱一年份，享有半價折扣" ],
      "Protect your online data—and choose a VPN subscription plan that works for you.":[ "保護您的線上資料 — 選擇適合您的 VPN 訂閱方案。" ],
      "Get Mozilla VPN":[ "下載 Mozilla VPN" ],
      "To find extensions compatible with Firefox for Android, %(linkStart)sclick here%(linkEnd)s.":[ "若要尋找相容於 Firefox for Android 的擴充套件，請%(linkStart)s點擊此處%(linkEnd)s。" ],
      "Add-ons are not compatible with Firefox for iOS. Try installing them on Firefox for desktop.":[ "Firefox for iOS 不支援附加元件功能，請將其安裝到 Firefox 桌面版。" ],
      "%(localizedSize)s B":[ "%(localizedSize)s B" ],
      "%(localizedSize)s KB":[ "%(localizedSize)s KB" ],
      "%(localizedSize)s MB":[ "%(localizedSize)s MB" ],
      "%(localizedSize)s GB":[ "%(localizedSize)s GB" ],
      "%(localizedSize)s TB":[ "%(localizedSize)s TB" ],
      "This add-on cannot be rated because no versions have been published.":[ "因為還沒有公開發布任何版本，無法對此附加元件評分。" ],
      "Read %(count)s review":[ "閱讀全部 %(count)s 條評論" ],
      "No reviews yet":[ "還沒有評論" ],
      "Rated %(ratingAverage)s by 1 reviewer":[ "由 1 位評論者給出 %(ratingAverage)s 分" ],
      "About this dictionary":[ "關於此字典" ],
      "About this extension":[ "關於此擴充套件" ],
      "About this language pack":[ "關於此語言套件" ],
      "About this theme":[ "關於此佈景主題" ],
      "About this add-on":[ "關於此附加元件" ],
      "Developer comments":[ "開發者留言" ],
      "This is not a public listing. You are only seeing it because of elevated permissions.":[ "這不是公開上架的項目，因為權限提升才會看到本項目。" ],
      "Extension Metadata":[ "擴充套件後設資料" ],
      Screenshots:[ "畫面擷圖" ],
      "Submit feedback or report an add-on to Mozilla":[ "向 Mozilla 檢舉附加元件，或送出意見回饋" ],
      "Custom License for %(addonName)s":[ "%(addonName)s 的自訂授權" ],
      "End-User License Agreement for %(addonName)s":[ "%(addonName)s 的終端使用者授權協議" ],
      "Privacy policy for %(addonName)s":[ "%(addonName)s 的隱私權保護政策" ],
      "Reviews and ratings for %(addonName)s. Find out what other users think about %(addonName)s and add it to your Firefox Browser.":[ "%(addonName)s 的評論與評分。看看其他的使用者覺得 %(addonName)s 如何，再安裝進您的 Firefox 瀏覽器。" ],
      "Show all reviews":[ "顯示所有評論" ],
      "Show only five-star reviews":[ "僅顯示五星評論" ],
      "Show only four-star reviews":[ "僅顯示四星評論" ],
      "Show only three-star reviews":[ "僅顯示三星評論" ],
      "Show only two-star reviews":[ "僅顯示二星評論" ],
      "Show only one-star reviews":[ "僅顯示一星評論" ],
      "Reviews for %(addonName)s":[ "%(addonName)s 的評論" ],
      "%(total)s review":[ "%(total)s 筆評論" ],
      "%(addonName)s version history - %(total)s version":[ "%(addonName)s 版本紀錄 - %(total)s 個版本" ],
      "Be careful with old versions! These versions are displayed for testing and reference purposes.":[ "小心舊版本！這些版本只是提供來測試與參考用。" ],
      "You should always use the latest version of an add-on.":[ "您應該隨時用最新版的附加元件。" ],
      Versions:[ "所有版本" ],
      "Latest version":[ "最新版本" ],
      "Older versions":[ "較舊版本" ],
      "%(addonName)s is restricted for violating Mozilla policies":[ "由於違反 Mozilla 政策規定，%(addonName)s 已被限制" ],
      "This add-on is restricted for violating Mozilla policies":[ "由於違反 Mozilla 政策規定，此附加元件已被限制" ],
      "%(addonName)s is blocked for violating Mozilla policies":[ "由於違反 Mozilla 政策規定，%(addonName)s 已被封鎖" ],
      "This add-on is blocked for violating Mozilla policies":[ "由於違反 Mozilla 政策規定，此附加元件已被封鎖" ],
      "Why did this happen?":[ "為什麼會發生？" ],
      "This extension, theme, or plugin violates %(startLink)sMozilla's add-on policies%(endLink)s.":[ "此擴充套件、佈景主題或外掛程式違反了 %(startLink)sMozilla 的附加元件政策%(endLink)s。" ],
      "What does this mean?":[ "這是什麼意思？" ],
      "Until the violation is resolved, this add-on won't be available for download from addons.mozilla.org. If it’s already installed, it will be disabled and users will be informed about the violation. They may choose to enable the add-on again at their own risk.":[ "解決這個違規問題之前，將無法從 addons.mozilla.org 下載此附加元件。使用者若已經安裝則將被停用，並收到此違規通知。他們仍可自行承擔風險，重新啟用附加元件。" ],
      "Until the violation is resolved, this add-on won't be available for download from addons.mozilla.org. It will be automatically disabled and no longer usable in Firefox.":[ "解決這個違規問題之前，將無法從 addons.mozilla.org 下載此附加元件。使用者若已經安裝則將被停用，不可再於 Firefox 使用。" ],
      "How does Mozilla enforce its policies?":[ "Mozilla 如何執行其政策？" ],
      "When Mozilla becomes aware of add-ons, plugins, or other third-party software that seriously compromise Firefox security, stability, or performance and meet %(criteriaStartLink)scertain criteria%(criteriaEndLink)s, the software may be blocked or restricted from general use. For more information, please read %(supportStartLink)sthis support article%(supportEndLink)s.":[ "當 Mozilla 發現有附加元件、外掛程式，或其他第三方軟體嚴重影響 Firefox 的安全性、穩定性、效能，而且符合%(criteriaStartLink)s某些條件%(criteriaEndLink)s，該軟體就可能被封鎖或受限，防止公眾使用。如果您想了解更多資訊，請閱讀%(supportStartLink)s這篇技術支援文章%(supportEndLink)s。" ],
      "View block request":[ "檢視封鎖請求" ],
      "All extension categories":[ "所有擴充套件分類" ],
      "All theme categories":[ "所有佈景主題分類" ],
      "Themes in %(categoryName)s":[ "%(categoryName)s 分類當中的佈景主題" ],
      "Extensions in %(categoryName)s":[ "%(categoryName)s 分類當中的擴充套件" ],
      "Do you really want to delete this collection?":[ "您真的要刪除這個收藏集嗎？" ],
      "Delete this collection":[ "刪除這個收藏集" ],
      "You reported this collection":[ "您已檢舉此收藏集" ],
      "We have received your report. Thanks for letting us know about your concerns with this collection.":[ "已收到您的檢舉內容。感謝讓我們知道這個收藏集可能有問題。" ],
      "Report this collection":[ "檢舉此收藏集" ],
      "Log in to create a collection":[ "登入後即可建立此收藏集" ],
      "Log in to edit this collection":[ "登入後即可編輯此收藏集" ],
      "First, create your collection. Then you can add extensions and themes.":[ "首先，請建立您的收藏集，然後就可以新增擴充套件與佈景主題。" ],
      "Search for extensions and themes to add to your collection.":[ "搜尋要加到收藏集的擴充套件與佈景主題。" ],
      "Download and create Firefox collections to keep track of favorite extensions and themes. Explore the %(collectionName)s—%(collectionDescription)s.":[ "下載並建立 Firefox 收藏集，以記錄您最愛的擴充套件與佈景主題。探索 %(collectionName)s—%(collectionDescription)s。" ],
      "Download and create Firefox collections to keep track of favorite extensions and themes. Explore the %(collectionName)s.":[ "下載並建立 Firefox 收藏集，以記錄您最愛的擴充套件與佈景主題。探索 %(collectionName)s。" ],
      "Submit feedback or report a collection to Mozilla":[ "向 Mozilla 檢舉收藏集，或送出意見回饋" ],
      "by %(authorName)s":[ "作者：%(authorName)s" ],
      "Report this collection to Mozilla":[ "向 Mozilla 檢舉此收藏集" ],
      "Send some feedback about the collection":[ "傳送有關收藏集的意見回饋" ],
      "Report the collection because it's illegal or incompliant":[ "檢舉某一套收藏集不符合相關法規" ],
      "My collections":[ "我的收藏集" ],
      Collections:[ "收藏集" ],
      "Log in to view your collections":[ "登入後即可檢視您的收藏集" ],
      "Collections make it easy to keep track of favorite add-ons and share your perfectly customized browser with others.":[ "收藏集將紀錄您所喜愛的附加元件，讓您與朋友分享完全自訂的瀏覽器。" ],
      "Create a collection":[ "建立收藏集" ],
      "You do not have any collections.":[ "您沒有任何收藏集。" ],
      Music:[ "音樂" ],
      Seasonal:[ "季節" ],
      "Firefox for Android extensions":[ "Firefox for Android 擴充套件" ],
      "Personalize Firefox for Android with powerful extensions.":[ "使用強大的擴充套件來個人化 Firefox for Android" ],
      "See more recommended extensions":[ "看更多推薦擴充套件" ],
      "Explore all Android extensions":[ "探索所有 Android 擴充套件" ],
      "See more trending extensions":[ "看更多熱門擴充套件" ],
      "Change the way Firefox looks with themes.":[ "使用佈景主題修改 Firefox 外觀。" ],
      "Download Firefox extensions and themes. They’re like apps for your browser. They can block annoying ads, protect passwords, change browser appearance, and more.":[ "下載 Firefox 擴充套件與佈景主題，它們就像是在瀏覽器中安裝外掛，可以封鎖討人厭的廣告、保護密碼、更改瀏覽器外觀，還有更多功能。" ],
      Abstract:[ "抽象派" ],
      Nature:[ "自然" ],
      "Film & TV":[ "電影與電視" ],
      Scenery:[ "風景" ],
      "See more top rated extensions":[ "看更多高分擴充套件" ],
      "See more recommended themes":[ "看更多推薦佈景主題" ],
      "See more trending themes":[ "看更多熱門佈景主題" ],
      "See more top rated themes":[ "看更多高分的佈景主題" ],
      "Download themes to change how Firefox looks. Tailor your experience to your tastes. Cute critters, evil robots, beautiful landscapes—thousands of options.":[ "下載佈景主題來變更 Firefox 的外觀。可根據自己的風格來調整您的體驗，不論是可愛小動物、邪惡機器人，或是美麗風景，有數以千計選項供您下載。" ],
      "Download Firefox Extensions to add features that customize browsing. Protect passwords, find deals, enhance video, and block annoying ads with browser apps.":[ "下載 Firefox 擴充套件，讓您加入功能來客製化上網體驗。可透過瀏覽器外掛來保護密碼、尋找購物折扣、加強看片體驗、封鎖廣告。" ],
      "Change your browser's appearance. Choose from thousands of themes to give Firefox the look you want.":[ "從數以千計的佈景主題中挑選一套，調整瀏覽器外觀，讓 Firefox 有您想要的樣子。" ],
      "Explore powerful tools and features to customize Firefox and make the browser all your own.":[ "瀏覽可用來自訂 Firefox 的強大工具與功能，讓瀏覽器有您的風格。" ],
      "Explore all categories":[ "瀏覽所有分類。" ],
      "Available for your locale":[ "您的語系可用的" ],
      "Dictionaries and Language Packs":[ "字典與語言套件" ],
      "Download Firefox dictionaries and language pack extensions. Add a new language option to your browser spell-checker, or change the browser's interface language.":[ "下載 Firefox 字典與語言套件。新增語言選項到您瀏覽器的拼字檢查工具，或變更瀏覽器界面語言。" ],
      "Installing a dictionary add-on will add a new language option to your spell-checker, which checks your spelling as you type in Firefox.":[ "安裝字典附加元件後，會在您的拼字檢查器當中新增語言選項，讓您可在 Firefox 打字時檢查拼字。" ],
      "Language packs change your browser's interface language, including menu options and settings.":[ "語言套件可更改您瀏覽器的介面語言，包含選單項目與設定內容。" ],
      "All Locales":[ "所有語系" ],
      "Locale Name":[ "語系名稱" ],
      "Language Packs":[ "語言套件" ],
      Dictionaries:[ "字典" ],
      "Submit feedback or report a review to Mozilla":[ "向 Mozilla 檢舉評論，或送出意見回饋" ],
      "by %(userName)s, %(timestamp)s":[ "作者：%(userName)s，%(timestamp)s" ],
      "Report this review to Mozilla":[ "向 Mozilla 檢舉此評論" ],
      "Report the review because it is illegal or incompliant":[ "回報某一筆評論不符合相關法規" ],
      "Want to interact with addons.mozilla.org (AMO) programmatically? Check out the %(startAddonsServerDocumentation)sAdd-ons Servers documentation%(endAddonsServerDocumentation)s for details about the APIs used by AMO and the %(startAddonsManager)sAdd-ons Manager%(endAddonsManager)s.":[ "想要使用程式與 addons.mozilla.org（AMO）互動嗎？請參考%(startAddonsServerDocumentation)s附加元件站伺服器文件%(endAddonsServerDocumentation)s，當中有 AMO 及%(startAddonsManager)s附加元件管理員%(endAddonsManager)s會用到的 API 詳細資訊。" ],
      "If you want to contribute but are not quite as technical, there are still ways to help:":[ "如果您對協助貢獻但不是技術人，還是可以幫忙:" ],
      "Participate in our %(startLink)sforum%(endLink)s.":[ "參與我們的%(startLink)s討論區%(endLink)s。" ],
      "Leave feedback for your favorite add-ons. Add-on authors are more likely to improve their add-ons and create new ones when they know people appreciate their work.":[ "為您最愛的附加元件留下意見回饋。當附加元件作者知道人們欣賞他們的作品，就更會改善附加元件並推出更新版本。" ],
      "Tell your friends and family that Firefox is a fast, secure browser that protects their privacy, and they can use add-ons to make it their own!":[ "告訴您的親朋好友 Firefox 是一套超快、超安全的瀏覽器，會保護人們的隱私，還可以用附加元件讓瀏覽器有自己的個性！" ],
      "To see more ways you can contribute to the add-on community, please visit our %(startLink)swiki%(endLink)s.":[ "請到我們的 %(startLink)swiki%(endLink)s 來瞭解能貢獻到附加元件社群的更多方式。" ],
      "Report an issue":[ "回報問題" ],
      "About Firefox Add-ons":[ "關於 Firefox 附加元件" ],
      "If you find a problem with the site, we'd love to fix it. Please file an %(startIssueLink)sissue%(endIssueLink)s and include as much detail as possible.":[ "若網站上有任何問題，我們樂意修正。請回報%(startIssueLink)s問題%(endIssueLink)s，並在當中盡可能包含詳細資訊讓我們知道，以便處理。" ],
      "The official Mozilla site for downloading Firefox extensions and themes. Add new features and change the browser’s appearance to customize your web experience.":[ "Mozilla 用來下載 Firefox 擴充套件與佈景主題的官方網站。可新增功能、更改瀏覽器外觀來客製化您的上網體驗。" ],
      "To report a security vulnerability for an extension, even if it is not hosted on this site, please file an %(startSecIssueLink)sissue%(endSecIssueLink)s on Bugzilla. All security vulnerability reports are %(startLink)sconfidential%(endLink)s.":[ "若要回報擴充套件的安全性問題（就算不是本網站提供的擴充套件），請到 Bugzilla %(startSecIssueLink)s開 issue 回報%(endSecIssueLink)s。所有回報的安全性漏洞都會%(startLink)s保持機密%(endLink)s。" ],
      "Get support":[ "獲得技術支援" ],
      "If you would like to learn more about how to manage add-ons in Firefox, or need to find general Firefox support, please visit %(startSUMOLink)sSupport%(endSUMOLink)s Mozilla. If you don't find an answer there, you can %(startForumLink)sask on our community forum%(endForumLink)s.":[ "若您想更加了解如何在 Firefox 管理附加元件，或是需要 Firefox 的一般技術支援，請到 %(startSUMOLink)sMozilla 技術支援站%(endSUMOLink)s。若您在那邊找不到答案，可以到%(startForumLink)s我們的社群討論區%(endForumLink)s問問題。" ],
      "%(startLink)sInformation about how to contact Mozilla's add-ons team can be found here%(endLink)s.":[ "%(startLink)s可在此處找到 Mozilla 附加元件團隊的聯絡方式%(endLink)s。" ],
      "Addons.mozilla.org (AMO), is Mozilla's official site for discovering and installing add-ons for the Firefox browser. Add-ons help you modify and personalize your browsing experience by adding new features to Firefox, enhancing your interactions with Web content, and changing the way your browser looks.":[ "Addons.mozilla.org（AMO）是 Mozilla 提供給 Firefox 瀏覽器使用者尋找並安裝附加元件的官方網站。附加元件可新增功能到 Firefox，讓您可修改並個人化您的上網體驗、加強您與網路內容的互動，並修改瀏覽器的外觀。" ],
      "If you are looking for add-ons for Thunderbird or SeaMonkey, please visit %(startTBLink)saddons.thunderbird.net%(endTBLink)s or %(startSMLink)saddons.thunderbird.net/seamonkey%(endSMLink)s.":[ "若您想找的是 Thunderbird 或 SeaMonkey 的附加元件，請到 %(startTBLink)saddons.thunderbird.net%(endTBLink)s 或 %(startSMLink)saddons.thunderbird.net/seamonkey%(endSMLink)s。" ],
      "A community of creators":[ "創作者社群" ],
      "The add-ons listed here are created by thousands of developers and theme designers from all over the world, ranging from individual hobbyists to large corporations. Some add-ons listed on AMO have been automatically published and may be subject to review by a team of editors once publicly listed.":[ "上架於此處的附加元件，是由全球數以千計的開發者及佈景主題設計師所創作的，這些人有的是業餘的個人，而有的則是大企業。部分在 AMO 上架的附加元件是由系統自動發佈，編輯團隊得審核這些公開上架的套件。" ],
      "Get involved":[ "參與其中" ],
      "Mozilla is a non-profit champion of the Internet, we build Firefox to help keep it healthy, open and accessible. Add-ons support user choice and customization in Firefox, and you can contribute in the following ways:":[ "Mozilla 是網際網路的非營利支持者，我們打造 Firefox 來保持網際網路的健康、開放，讓任何人都可自由使用。附加元件提供使用者不同選擇及自訂的機會，您也可以透過下列方式進行貢獻:" ],
      "%(startLink)sMake your own add-on%(endLink)s. We provide free hosting and update services and can help you reach a large audience of users.":[ "%(startLink)s打造您自己的附加元件%(endLink)s。我們提供免費的主機代管空間及更新服務，可協助您接觸大量使用者。" ],
      "Help improve this website. It's open source, and you can file bugs and submit patches. You can get started with a %(startGoodFirstBugLink)sgood first bug%(endGoodFirstBugLink)s or view all open issues for AMO’s %(startAddonsServerRepoLink)sserver%(endAddonsServerRepoLink)s and %(startAddonsFrontendRepoLink)sfrontend%(endAddonsFrontendRepoLink)s on Github.":[ "協助改善此網站。這個網站的原始碼是開放的，您可以回報 Bug 或送出補綴。您可以先從%(startGoodFirstBugLink)s新手好 bug（good first bug）%(endGoodFirstBugLink)s開始上手，或是看看目前 Github 上，AMO 的%(startAddonsServerRepoLink)s伺服器%(endAddonsServerRepoLink)s和%(startAddonsFrontendRepoLink)s前端介面%(endAddonsFrontendRepoLink)s有哪些尚未處理的問題。" ],
      "Include your own or anyone else’s email, phone number, or other personal details.":[ "包含您自己或別人的電子郵件地址、電話號碼或其他任何個資。" ],
      "Post reviews for an add-on you or your organization wrote or represent.":[ "為您自己或者您的組織開發的附加元件撰寫評論。" ],
      "Criticize an add-on for something it’s intended to do. For example, leaving a negative review of an add-on for displaying ads or requiring data gathering, when that is the intended purpose of the add-on, or the add-on requires gathering data to function.":[ "批評附加元件本來就打算要作的功能。舉例來說，若某套附加元件本來就需要收及某些資料才能運作，或是顯示廣告才可運作，您就不該對這樣的功能留下負面評論。" ],
      "Frequently Asked Questions about Reviews":[ "關於評論的常見問題" ],
      "How can I report a problematic review?":[ "我要如何回報有問題的評論？" ],
      "Please report or flag any questionable reviews by clicking the \"Report this review\" and it will be submitted to the site for moderation. Our moderation team will use the Review Guidelines to evaluate whether or not to delete the review or restore it back to the site.":[ "請點擊「回報這則評論」來回報或標示可能有問題的評論，該評論將被交給管理團隊審查。審查團隊將依照評論撰寫指南當中的標準，來評估是否要刪除該評論。" ],
      "I'm an add-on author, can I respond to reviews?":[ "我是附加元件作者，我可以回應評論嗎？" ],
      "Yes, add-on authors can provide a single response to a review. You can set up a discussion topic in our %(startLink)sforum%(endLink)s to engage in additional discussion or follow-up.":[ "可以，附加元件作者可為每則評論留下一筆回覆。您也可以在我們的%(startLink)s討論區%(endLink)s開設討論主題，作更多後續討論。" ],
      "I'm an add-on author, can I delete unfavorable reviews or ratings?":[ "我是附加元件作者，我可以刪除對我不利的評論和評分嗎？" ],
      "In general, no. But if the review did not meet the review guidelines outlined above, you can click \"Report this review\" and have it moderated. If a review included a complaint that is no longer valid due to a new release of your add-on, we may consider deleting the review.":[ "一般來說，不會。但若該評論未遵守上方的指南，您可以點擊「回報這則評論」讓我們確認。若該評論當中的抱怨因為新版本推出已經不存在，我們可能會考慮刪除該筆評論。" ],
      "Review Guidelines":[ "評論撰寫指南" ],
      "Guidelines, tips, and Frequently Asked Questions to leave a review for the extensions and themes you’ve downloaded and used on Firefox.":[ "對您為 Firefox 下載安裝的擴充套件與佈景主題留下評論時的指南、秘訣、常見問題。" ],
      "Add-on reviews are a way for you to share your opinions about the add-ons you’ve installed and used. Our review moderation team reserves the right to refuse or remove any review that does not comply with these guidelines.":[ "您可以對安裝使用過的附加元件留言評論，來分享您的想法。我們的評論管理團隊保留拒絕和移除任何不遵守《評論撰寫指南》的評論內容的權力。" ],
      "Tips for writing a great review":[ "撰寫優良評論的小秘訣" ],
      "Do:":[ "請做：" ],
      "Write like you are telling a friend about your experience with the add-on.":[ "寫得像您在和朋友分享附加元件的經驗。" ],
      "Keep reviews concise and easy to understand.":[ "保持評論準確，容易理解。" ],
      "Give specific and helpful details. For example:":[ "提供清楚並有幫助的資訊。例如:" ],
      "Did the add-on work as you expected it to?":[ "附加元件如您所預期的執行嗎？" ],
      "What features did you like or dislike?":[ "您喜歡或不喜歡哪些功能？" ],
      "Was it useful?":[ "該附加元件有用嗎？" ],
      "Was it easy to use?":[ "該附加元件容易使用嗎？" ],
      "Will you continue to use this add-on?":[ "您會繼續使用該附加元件嗎？" ],
      "Take a moment to read your review before submitting it to minimize typos.":[ "送出前花一點時間閱讀一下您的評論內容，避免打錯字。" ],
      "Don't:":[ "請不要:" ],
      "Submit one-word reviews such as \"Great!\", \"wonderful,\" or \"bad\".":[ "送出太短的評論，例如「讚！」、「酷！」、「Good!」。" ],
      "Post technical issues, support requests, or feature suggestions. Use the available support options for each add-on, if available. You can find them in the \"More information\" section in the sidebar on the add-on's detail page.":[ "張貼技術問題、技術支援請求或功能建議。請使用每套附加元件的技術支援選項（若有的話），您可在每套附加元件的詳細資訊頁面側邊欄當中的「更多資訊」區段找到相關資訊。" ],
      "Write reviews for add-ons which you have not personally used.":[ "還沒有使用過附加元件，就直接寫評論。" ],
      "Use profanity, sexual language or language that can be construed as hateful.":[ "使用褻瀆、性暗示或者帶有恨意的言語。" ],
      "Include HTML, links, source code or code snippets. Reviews are meant to be text only.":[ "包含 HTML、超連結、程式碼等。評論內容請只留下純文字。" ],
      "Make false statements, disparage add-on authors or personally insult them.":[ "作虛假評論、貶低附加元件作者或者羞辱個人。" ],
      "Add-ons tagged with %(tag)s":[ "加上 %(tag)s 標籤的附加元件" ],
      "Submit feedback or report a user to Mozilla":[ "向 Mozilla 檢舉使用者，或送出意見回饋" ],
      "User since":[ "加入日期" ],
      "Report this user to Mozilla":[ "向 Mozilla 檢舉此使用者" ],
      "Send some feedback about the user profile":[ "傳送有關使用者的意見回饋" ],
      "Report the user profile because it's illegal or incompliant":[ "回報某一位使用者不符合相關法規" ],
      "My reviews":[ "我的評論" ],
      "The profile of %(user)s, a Firefox extension and theme author. Find other apps by %(user)s, including average ratings, tenure, and the option to report issues.":[ "Firefox 擴充套件與佈景主題作者 %(user)s 的資料。尋找其他由 %(user)s 開發的應用程式，包含平均評分、使用時間長度以及回報問題的選項。" ],
      "The profile of %(user)s, Firefox extension author. Find other extensions by %(user)s, including average ratings, tenure, and the option to report issues.":[ "Firefox 擴充套件作者 %(user)s 的資料。尋找其他由 %(user)s 開發的擴充套件，包含平均評分、使用時間長度以及回報問題的選項。" ],
      "The profile of %(user)s, Firefox theme author. Find other themes by %(user)s, including average ratings, tenure, and the option to report issues.":[ "Firefox 佈景主題作者 %(user)s 的資料。尋找其他由 %(user)s 開發的佈景主題，包含平均評分、使用時間長度以及回報問題的選項。" ],
      "User Avatar":[ "使用者大頭照" ],
      "Add-ons developer":[ "附加元件開發者" ],
      "Theme artist":[ "佈景主題藝術家" ],
      "User Profile for %(user)s":[ "%(user)s 的使用者資料" ],
      "User Profile":[ "使用者資料" ],
      Occupation:[ "職業" ],
      "Number of add-ons":[ "附加元件數量" ],
      "Average rating of developer’s add-ons":[ "此開發者的附加元件平均分數" ],
      Biography:[ "自我介紹" ],
      "Edit profile":[ "編輯個人資料" ],
      "Admin user":[ "管理員使用者" ],
      "Picture successfully deleted":[ "已成功刪除照片" ],
      "Tell users a bit more information about yourself. Most fields are optional, but they'll help other users get to know you better.":[ "請告訴其他使用者關於您的更多資訊。大部分欄位為選填，但能夠幫助其他人更加了解您。" ],
      "Tell users a bit more information about this user. Most fields are optional, but they'll help other users get to know %(userName)s better.":[ "請告訴其他使用者關於這位使用者的更多資訊。大部分欄位為選填，但能夠幫助其他人更加了解 %(userName)s。" ],
      "Introduce yourself to the community if you like":[ "若您願意的話，歡迎您向整個社群自我介紹一下" ],
      "Introduce %(userName)s to the community":[ "介紹 %(userName)s 給社群成員認識" ],
      "Log in to edit the profile":[ "登入後即可編輯個人資料" ],
      "Creating your profile…":[ "正在建立您的帳號…" ],
      "Create My Profile":[ "建立我的帳號" ],
      "Updating your profile…":[ "正在更新您的帳號…" ],
      "Update My Profile":[ "更新我的帳號" ],
      "Updating profile…":[ "正在更新帳號…" ],
      "Update Profile":[ "更新帳號" ],
      "View user's profile":[ "檢視使用者的個人資料" ],
      "Edit user's profile":[ "編輯使用者的個人資料" ],
      Account:[ "帳號" ],
      "Account for %(userName)s":[ "%(userName)s 的帳號" ],
      "Email Address":[ "電子郵件地址" ],
      "Email address cannot be changed here":[ "無法在此修改電子郵件信箱" ],
      "You can change your email address on Mozilla accounts. %(startLink)sNeed help?%(endLink)s":[ "您可到 Mozilla 帳號網站修改信箱。%(startLink)s需要幫助嗎？%(endLink)s" ],
      "Manage Mozilla accounts…":[ "管理 Mozilla 帳號…" ],
      Profile:[ "個人資料" ],
      "This field is required":[ "此欄位必填" ],
      "Display Name *":[ "顯示名稱 *" ],
      "This URL will only be visible for users who are developers.":[ "此網址只會顯示給其他開發者看到。" ],
      "Some HTML supported: %(htmlTags)s. Links are forbidden.":[ "支援部分 HTML: %(htmlTags)s。不允許使用鏈結。" ],
      Notifications:[ "通知" ],
      "From time to time, Mozilla may send you email about upcoming releases and add-on events. Please select the topics you are interested in.":[ "有時候 Mozilla 可能會寄給您即將釋出的版本和附加元件活動。請選擇您感興趣的主題。" ],
      "From time to time, Mozilla may send this user email about upcoming releases and add-on events. Please select the topics this user may be interested in.":[ "有時候 Mozilla 可能會寄送即將釋出的版本和附加元件活動相關資訊給此使用者。請選擇這位使用者感興趣的主題。" ],
      "Mozilla reserves the right to contact you individually about specific concerns with your hosted add-ons.":[ "Mozilla 保留使用此資訊與您聯絡，詢問關於您放上網的附加元件相關問題的權利。" ],
      "Delete My Profile":[ "刪除我的帳號" ],
      "Delete Profile":[ "刪除帳號" ],
      "IMPORTANT: Deleting your Firefox Add-ons profile is irreversible.":[ "重要: 刪除您的 Firefox 附加元件站帳號後無法恢復。" ],
      "IMPORTANT: Deleting this Firefox Add-ons profile is irreversible.":[ "重要: 刪除此 Firefox 附加元件站帳號後無法恢復。" ],
      "Your data will be permanently removed, including profile details (picture, user name, display name, location, home page, biography, occupation), notification preferences, reviews, and collections.":[ "將永久刪除您的資料，包含個人詳細資料（大頭照、使用者名稱、顯示名稱、所在地點、首頁、自傳、工作）、通知偏好設定、評論與收藏集資訊。" ],
      "The user’s data will be permanently removed, including profile details (picture, user name, display name, location, home page, biography, occupation), notification preferences, reviews, and collections.":[ "將永久刪除該使用者的資料，包含個人詳細資料（大頭照、使用者名稱、顯示名稱、所在地點、首頁、自傳、工作）、通知偏好設定、評論與收藏集資訊。" ],
      "If you authored any add-ons they will also be deleted, unless you share ownership with other authors. In that case, you will be removed as an author and the remaining authors will maintain ownership of the add-on.":[ "若您是任何附加元件的唯一作者，這些附加元件也將被刪除。若您與其他作者共享附加元件的所有權，則將從該元件的作者名單中移除，其餘的作者將繼續擁有該附加元件。" ],
      "If the user authored any add-ons they will also be deleted, unless ownership is shared with other authors. In that case, the user will be removed as an author and the remaining authors will maintain ownership of the add-on.":[ "若該使用者是任何附加元件的唯一作者，其附加元件也將被刪除。若該使用者與其他作者共享附加元件的所有權，則將從該元件的作者名單中移除，其餘的作者將繼續擁有該附加元件。" ],
      "When you use this email address to log in again to addons.mozilla.org, your profile on Firefox Add-ons will not have access to any of its previous content.":[ "就算未來再次使用此電子郵件地址登入 addons.mozilla.org，新的 Firefox 附加元件站帳號也無法再存取原帳號內容。" ],
      Unsubscribe:[ "取消訂閱" ],
      "You are successfully unsubscribed!":[ "已成功退訂！" ],
      "The email address %(strongStart)s%(email)s%(strongEnd)s will no longer get messages when:":[ "下列情況時，電子郵件信箱 %(strongStart)s%(email)s%(strongEnd)s 將不再收到訊息:" ],
      "You can edit your notification settings by %(linkStart)sediting your profile%(linkEnd)s.":[ "您可以%(linkStart)s編輯個人資料頁%(linkEnd)s當中的通知設定。" ],
      "(no name)":[ "（無名稱）" ],
      "%(application)s %(minVersion)s and later":[ "%(application)s %(minVersion)s 與更新版本" ],
      "%(application)s %(minVersion)s to %(maxVersion)s":[ "%(application)s %(minVersion)s 到 %(maxVersion)s" ],
      "Works with %(listOfApplicatonsAndVersions)s":[ "適用於 %(listOfApplicatonsAndVersions)s" ],
      "Installation aborted because the add-on appears to be corrupt.":[ "由於附加元件看來已毀損，安裝中斷。" ],
      "Installation failed. Please try again.":[ "安裝失敗，請再試一次。" ],
      "Download failed. Please check your connection.":[ "下載失敗，請檢查網路連線。" ],
      "An unexpected error occurred during installation.":[ "安裝時發生未預期的錯誤。" ],
      "An unexpected error occurred during uninstallation.":[ "移除時發生未預期的錯誤。" ],
      "An unexpected error occurred.":[ "發生未預期的錯誤。" ],
      "stay up-to-date with news and events relevant to add-on developers (including the about:addons newsletter)":[ "取得與附加元件開發者有關的最新消息與活動資訊（包含 about:addons 電子報）" ],
      "Mozilla needs to contact me about my individual add-on":[ "Mozilla 需要聯繫關於我自己的附加元件" ],
      "new add-ons or Firefox features are available":[ "有新的附加元件或 Firefox 功能可用" ],
      "someone writes a review of my add-on":[ "某位使用者評論我的附加元件" ],
      "an add-on developer replies to my review":[ "某位附加元件的開發者回覆我的評論" ],
      "my add-on is reviewed by a reviewer":[ "審核者已經審核我的附加元件" ],
      "my add-on's compatibility cannot be upgraded":[ "無法升級我的附加元件相容性" ],
      "my add-on's compatibility is upgraded successfully":[ "成功升級我的附加元件相容性" ],
      "Official add-on built by Mozilla Firefox. Meets security and performance standards.":[ "由 Mozilla Firefox 打造的官方附加元件，符合各種安全性與運作效能標準。" ],
      "Firefox only recommends add-ons that meet our standards for security and performance.":[ "Firefox 僅推薦符合我們的安全性與運作效能標準的附加元件。" ] } },
  _momentDefineLocale:function anonymous(
) {

      // By requiring this module, the new locale is defined and
      // registered internally for moment.js
      require('moment/locale/zh-tw');
},
  _cacheBust:"2018.08.02" }